import { User } from 'shared/classes/user';
import { TargetGroup, TARGETGROUP_DUMMIES } from 'shared/models/target-groups/target-group';

export class TargetGroupsHelper {
  private targetGroups: Array<TargetGroup>;

  constructor(targetGroups: Array<TargetGroup>) {
    this.targetGroups = targetGroups;
  }

  public getTargetGroups(user: User): Array<TargetGroup> {
    return this.targetGroups.filter((targetGroup) => {
      return !TARGETGROUP_DUMMIES.includes(targetGroup.title) && this.userIsInTargetGroup(user, targetGroup);
    });
  }

  public userIsInTargetGroup(user: User, targetGroup: TargetGroup): boolean {
    if (!targetGroup) {
      return true;
    }

    const target:TargetGroup = targetGroup;

    // not implemented/used yet
    if (!this._isEmptyOrOverlaps(target.groups, user.groups)) {
      return false;
    }

    if (!this._isEmptyOrOverlaps(target.categories, user.categories)) {
      return false;
    }

    if (!this._isEmptyOrOverlaps(target.roles, user.roles)) {
      return false;
    }

    if (target.companies && target.companies.length > 0 && (!user.company || !user.company._id || !this._hasElement(target.companies, user.company))) {
      return false;
    }

/*    // not implemented/used yet
    if (target.sex && target.sex !== user.sex) {
      return false;
    }

    if (target.managementLevel && target.managementLevel.length > 0 && !this._hasElement(target.managementLevel, user.managementLevel)) {
      return false;
    }

    const targetHasManagementLevelOrder = target.managementLevelOrder != null &&
                                         target.managementLevelOrder !== undefined &&
                                         target.managementLevelOrder.length > 0;

    const userHasManagementLevel = user.managementLevel != null && user.managementLevel !== undefined;
    if (targetHasManagementLevelOrder &&
       (!userHasManagementLevel || target.managementLevelOrder.indexOf(user.managementLevel.level) < 0)) {
      return false;
    }

    const targetHasMinAge = target.minAge !== null && target.minAge !== undefined;
    const targetHasMaxAge = target.maxAge !== null && target.maxAge !== undefined;
    const userHasAge = user.birthdate !== null && user.birthdate !== undefined;
    let userAge = -1;
    if (userHasAge && (targetHasMinAge || targetHasMaxAge)) {
      const userDateTime = moment.utc()
        .add(user.diffFromUTC, 'minutes');

      userAge = userDateTime.diff(moment.utc(user.birthdate), 'years');
    }

    if (targetHasMinAge && (!userHasAge || userAge < target.minAge)) {
      return false;
    }

    if (targetHasMaxAge && (!userHasAge || userAge > target.maxAge)) {
      return false;
    }*/

    return true;
  }

  private _isEmptyOrOverlaps(sourceArray, checkArray) {
    if (sourceArray === null || sourceArray === undefined || sourceArray.length === 0) {
      return true;
    }

    const elementFound = sourceArray.some((arrayElement) => {
      return this._hasElement(checkArray, arrayElement);
    });

    return elementFound;
  }

  private _hasElement(array, element) {
    if (array === null || array === undefined || array.length === 0 || element === null || element === undefined) {
      return false;
    }

    const elementFound = array.some((arrayElement) => {
      return arrayElement._id.toString() === element._id.toString();
    });

    return elementFound;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/helper/targetGroupsHelper.ts